import { Row, DatePicker, Col, Drawer } from "antd";
import React, { useEffect, useState } from "react"
import { Number as CardNumber } from "../../chart/number/Number";
import { PhoneTwoTone } from "@ant-design/icons";
import Pie from "../../chart/pie/Pie";
import SwarmPlot from "../../chart/swarmPlot/SwarmPlot";
import moment, { Moment } from "moment";
import { AnalyticsDate, CallPerf } from "../../../../model/analytics/types";
import { useDispatch, useSelector } from "react-redux";
import { getAllEventsAction } from "../../../../business/actions/analyticsActions";
import { RootState } from "../../../../model/rootReducer";
import DateRangePicker from "../../../system/dateRangePicker/DateRangePicker";
import { Container, Input, MySlider, RoundedTable } from "./Styled";
import AnalyticsDrawer from "../analyticsDetails/AnalyticsDetails";
import { columns, formatEventsCluster, formatEventsCounter, formatEventsDuration } from "../../../../helpers/analyticsHelper";
import { AnalyticsTooltip } from "../analyticsTooltip/AnalyticsTooltip";
import { toDatePicker } from "../../../../helpers/dateFormatHelper";
const { RangePicker } = DatePicker;

const groups = ['play', 'request', 'transcript', 'startvoice', 'speech']

type AnalyticsGlobalProps = {
    globalPerf: CallPerf;
    dates: AnalyticsDate;
}

const AnalyticsGlobal: React.FunctionComponent<AnalyticsGlobalProps> = ({
    globalPerf,
    dates
}) => {
    const dispatch = useDispatch()
    const selectedBotId = useSelector((state: RootState) => state.bot.selectedBot)
    const [durations, setDurations] = useState([0, 0])
    const [durationRange, setDurationRange] = useState([0, 0])
    const [visible, setVisible] = useState(false)
    const [selectedCluster, setSelectedCluster] = useState<any>();
    const [filter, setFilter] = useState({
        startDate: dates.startDate,
        endDate: dates.endDate,
    })

    const onIntervalChange = (startDate: Moment, endDate: Moment) => {
        setFilter({
            ...filter,
            startDate: startDate,
            endDate: endDate,
        })
    }

    const showDrawer = (event: any) => {
        setVisible(true)
        setSelectedCluster(event.data);
    }
    const onClose = () => {
        setVisible(false)
    }

    useEffect(() => {
        if (selectedBotId) {
            dispatch(getAllEventsAction.request({
                startDate: toDatePicker(filter.startDate),
                endDate: toDatePicker(filter.endDate)
            }));
        }
    }, [selectedBotId, filter])

    useEffect(() => {
        var max = Number.MIN_SAFE_INTEGER
        var min = Number.MAX_SAFE_INTEGER
        Object.entries(globalPerf.statistics).map(([key, val]) => {
            if (val.maxMilliseconds > max) {
                max = val.maxMilliseconds
            }
            if (val.minMilliseconds < min) {
                min = val.minMilliseconds
            }
        })
        setDurationRange([min, max]);
        setDurations([min, max]);
    }, [globalPerf, selectedBotId])

    return (
        <>
            <DateRangePicker
                startDate={dates.startDate}
                endDate={dates.endDate}
                onChange={onIntervalChange}
            />
            <Row style={{ marginTop: "6px" }} gutter={[16, 16]}>
                <Col span={6}>
                    <CardNumber
                        style={{ height: "160px", marginBottom: "10px" }}
                        color={{
                            "0%": "#108ee9",
                            "100%": "#ab2cf4"
                        }}
                        title="Nombre d'appels"
                        text={globalPerf.callNumber.toString()}
                        percent={100}
                        Icon={
                            <PhoneTwoTone
                                style={{ fontSize: "30px" }}
                                twoToneColor="#ab2cf4"
                            />
                        }
                    />
                    <CardNumber
                        style={{ height: "160px" }}
                        color={{
                            "0%": "#E03D5D",
                            "100%": "#E6397E"
                        }}
                        title="Nombre de potentiels incidents"
                        text={globalPerf.incidentNumber.toString()}
                        percent={100}
                        Icon={
                            <PhoneTwoTone
                                style={{ fontSize: "30px" }}
                                twoToneColor="#E03D5D"
                            />
                        }
                    />
                </Col>
                <Col span={11}>
                    <RoundedTable columns={columns} dataSource={formatEventsDuration(globalPerf.statistics)} pagination={false} />
                </Col>
                <Col span={6}>
                    <Pie title="Événements" data={formatEventsCounter(globalPerf.statistics)} />
                </Col>
            </Row>
            <SwarmPlot data={formatEventsCluster(globalPerf.clusters, durations)} groups={groups} title="Événements" durationRange={durations} tooltip={AnalyticsTooltip} showDrawer={showDrawer} />
            <Container >
                <Input
                    size="small"
                    value={durations[0]}
                    onChange={(val) => setDurations([parseInt(val!.toString()), durations[1]])}
                />
                <Col span={21}>
                    <MySlider value={[durations[0], durations[1]]} min={durationRange[0]} max={durationRange[1]} range onChange={(e: any) => { setDurations([e[0], e[1]]) }} />
                </Col>
                <Input
                    size="small"
                    defaultValue={1}
                    value={durations[1]}
                    onChange={(val) => setDurations([durations[0], parseInt(val!.toString())])}
                />
            </Container>
            <Drawer
                title={`${selectedCluster?.group} : ${selectedCluster?.range.minMilliseconds} - ${selectedCluster?.range.maxMilliseconds} ms `}
                placement="right"
                closable={false}
                onClose={onClose}
                visible={visible}
                width={500}
            >
                <AnalyticsDrawer data={selectedCluster} visible={visible} />
            </Drawer>
        </>
    )
}

export default AnalyticsGlobal